import type { Selector } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

import { getSessionFlags } from "@/shop/reducers/session";

import type { IIndustryState } from "./types";

export const getIndustryState: Selector<{ industry: IIndustryState }, IIndustryState> = (state) => state.industry;

export const getShowTreeNodeCounts = createSelector(getSessionFlags, (flags) => Boolean(flags?.showTreeNodeCounts));
